import {
    ComponentRef,
    Directive,
    PendingTasks,
    ViewContainerRef,
    effect,
    inject,
    input
} from '@angular/core';

import { COMPONENTS } from '../../component/component.imports';

@Directive({
    selector: '[dynamic]',
    standalone: true
})
export class RendererDirective {
    private readonly vcr = inject(ViewContainerRef);
    private readonly pendingTasks = inject(PendingTasks);

    private componentRef?: ComponentRef<any>;
    private version = 0;

    readonly model = input<any>(undefined, { alias: 'dynamic' });

    constructor() {
        effect(() => {
            const model = this.model();
            const version = ++this.version;

            if (!model) {
                this.clear();
                return;
            }

            void this.pendingTasks.run(
                () => this.render(model, version)
            );
        });
    }

    private async render(model: any, version: number): Promise<void> {
        const loader = COMPONENTS[model.component];

        if (!loader) {
            return;
        }

        const component = await loader();

        if (version !== this.version) {
            return;
        }

        if (this.componentRef?.componentType !== component) {
            this.clear();

            this.componentRef = this.vcr.createComponent(component);
        }

        this.componentRef.setInput('model', model);
    }

    private clear(): void {
        this.vcr.clear();
        this.componentRef = undefined;
    }
}
